import { map } from 'lodash'

const foodMoodRelationsDetailsFormInitialValues = ({ dishTypes }) => ({
  dishTypes: map(dishTypes, 'id'),
})

export default foodMoodRelationsDetailsFormInitialValues
